import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import RealisationMcDonalds from "../components/RealisationMcDonalds";

const mapStateToProps = state => ({
  lng:  state.locale.lng
});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RealisationMcDonalds);
const withTranslationComponent = withTranslation(["realisations", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/RealisationMcDonalds.js